import { Redirect } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { firestoreConnect } from 'react-redux-firebase';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import ThermageLogo from '../../images/thermage_eyes.svg';
//import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Divider from '@material-ui/core/Divider';
import LogoHeader from '../Header';
import { updateUserPassword, closeAuthPopUps } from '../../actions/authActions';
import LoadingBlock from '../Loading';
import TextField from '@material-ui/core/TextField';
//import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { ClearBrilliantButton } from '../Buttons/clearBrilliantButton';
import firebase from 'firebase/app';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import * as PROVINCES from '../../constants/provinces';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import NativeSelect from '@material-ui/core/NativeSelect';

const styles = {
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: 2,
    textAlign: 'left',
    color: '#000',
  },
  customerName: {
    fontFamily: 'Montserrat',
    fontWeight: 300,
    color: '#0080B2',
    fontSize: 48,
    '@media (max-width: 1025px)': {
      fontSize: 28,
    },
    '@media (max-width: 599px)': {
      textAlign: 'center',
    },
  },
  logo: {
    marginTop: 30,
    width: 155,
    display: 'block',
    '@media (max-width: 1025px)': {
      width: 135,
      marginLeft: -40,
      marginTop: 0,
    },
  },
  alignCenter: {
    textAlign: 'center',
  },
  questionMark: {
    right: -50,
    display: 'block',
    position: 'absolute',
    top: 0,
    '@media (max-width: 1440px)': {
      right: -70,
    },
    '@media (max-width: 1300px)': {
      right: -85,
    },
    '@media (max-width: 1025px)': {
      right: -30,
    },
    '@media (max-width: 850px)': {
      right: -50,
    },
    '@media (max-width: 599px)': {
      right: -30,
    },
  },
  logoBlock: {
    position: 'relative',
    display: 'block',
  },
  mobileCenter: {
    '@media (max-width: 599px)': {
      textAlign: 'center',
    },
  },
  textField: {
    width: '100%',
  },
  magrinTopBlock: {
    paddingTop: '30px',
  },
};

const INITIAL_STATE = {
  currentPassword: '',
  newPassword: '',
  checkPassword: '',
  loading: true,
  firstName: '',
  lastName: '',
  profileUpdated: false,
  phoneNumber: '',
  emailCommuncation: false,
  textCommunication: false,
  prov: '',
  canadianProvinces: [PROVINCES.ONTARIO, PROVINCES.QUEBEC, PROVINCES.BRITISH_COLUMBIA, PROVINCES.ALBERTA, PROVINCES.NOVA_SCOTIA, PROVINCES.NEW_BRUNSWICK, PROVINCES.MANITOBA, PROVINCES.PRINCE_EDWARD_ISLAND, PROVINCES.SASKATCHEWAN, PROVINCES.NEWFOUNDLAND],
};

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

class ProfilePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
    };
  }

  componentDidMount() {
    this.setState({ a: true });
  }

  componentWillUnmount() {}

  componentDidUpdate() {
    //this.setState({ loading: true });
    if (this.state.loading) {
      if (this.props.user.isLoaded) {
        if (this.props.user) {
          this.setState({
            firstName: this.props.user.firstName ? this.props.user.firstName : '',
            lastName: this.props.user.lastName ? this.props.user.lastName : '',
            prov: this.props.user.province ? this.props.user.province : '',
            phoneNumber: this.props.user.phoneNumber ? this.props.user.phoneNumber : '',
            textCommunication: this.props.user.phoneOpt ? this.props.user.phoneOpt : false,
            emailCommuncation: this.props.user.emailOpt ? this.props.user.emailOpt : true,
            loading: false,
          });
        }
      }
    }
  }

  changePassword = (event) => {
    event.preventDefault();
    if (this.state.newPassword !== this.state.checkPassword) {
      this.setState({
        passwordError: 'Passwords do not match',
      });
    } else {
      // Need to put in some checks to see if password is strong enough

      this.props.updateUserPassword({ currentPassword: this.state.currentPassword, email: this.props.user.email, newPassword: this.state.newPassword });

      this.setState({
        currentPassword: '',
        newPassword: '',
        checkPassword: '',
        passwordOpen: false,
      });
    }
  };

  updateProfile = async () => {
    try {
      await firebase.firestore().collection('consumer').doc(this.props.auth.uid).update({
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        province: this.state.prov,
      });

      this.setState({
        profileUpdated: true,
      });
    } catch (e) {}
  };

  communcationOptions = async () => {
    try {
      await firebase.firestore().collection('consumer').doc(this.props.auth.uid).update({
        phoneNumber: this.state.phoneNumber,
        phoneOpt: this.state.textCommunication,
        emailOpt: this.state.emailCommuncation,
      });

      this.setState({
        profileUpdated: true,
      });
    } catch (e) {}
  };

  closePopUps = () => {
    this.setState({
      profileUpdated: false,
    });
    this.props.closeAuthPopUps();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  render() {
    const { currentPassword, newPassword, checkPassword, firstName, lastName, profileUpdated, phoneNumber, emailCommuncation, textCommunication, canadianProvinces, prov } = this.state;

    const { auth, t, classes, user, authError, authMessage, authErrorPopUp, authPopUp } = this.props;
    if (!auth.uid) return <Redirect to={ROUTES.LOGIN} />;
    //console.log('this is my user', user);

    if (user.isLoaded && !user.isEmpty) {
      return (
        <div className='meta-react'>
          <LogoHeader t={t} />
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className={classes.root}>
                  <Grid container spacing={3} justifyContent='center'>
                    <Grid item xs={12} sm={6}>
                      <Typography variant='h5' className={classes.mobileCenter}>
                        {t('profile.title')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid container spacing={1} alignItems='center' justifyContent='center'>
                        <Grid item xs={3}></Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item container spacing={3} xs={12} alignItems='flex-start' justifyContent='center' style={{ marginTop: 30 }}>
                      <Grid item sm={4} xs={12} container spacing={4} alignItems='center' justifyContent='center'>
                        <form onSubmit={this.updateProfile}>
                          <Grid item xs={12}>
                            <Typography variant='h6' gutterBottom>
                              {user.email}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField id='firstName' label={t('profile.firstName')} autoComplete='first-name' name='firstName' value={firstName} onChange={this.onChange} className={classes.textField} />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField id='lastName' label={t('profile.lastName')} autoComplete='last-name' name='lastName' value={lastName} onChange={this.onChange} className={classes.textField} />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControl className={classes.formControl}>
                              <InputLabel htmlFor='age-native-helper'>{t('signUp.yourProvince')}</InputLabel>
                              <NativeSelect onChange={this.onChange} name='prov' value={prov}>
                                <option value=''></option>
                                {canadianProvinces.map((p) => (
                                  <option key={p.abbrev} value={p.abbrev}>
                                    {p.name}
                                  </option>
                                ))}
                              </NativeSelect>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} align='center' className={classes.magrinTopBlock}>
                            <ClearBrilliantButton variant='contained' color='primary' onClick={this.updateProfile}>
                              {t('profile.updateProfile')}
                            </ClearBrilliantButton>
                          </Grid>
                        </form>
                      </Grid>
                      <Grid item sm={4} xs={12} container spacing={4} alignItems='center' justifyContent='center'>
                        <form onSubmit={this.changePassword}>
                          <Grid item xs={12}>
                            <Typography variant='h6'>{t('profile.changePassTitle')}</Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField id='standard-password-input' label={t('profile.currentPassword')} type='password' autoComplete='current-password' name='currentPassword' value={currentPassword} onChange={this.onChange} className={classes.textField} />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField id='newPassword' name='newPassword' label={t('profile.newPassword')} type='password' value={newPassword} onChange={this.onChange} className={classes.textField} />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField id='checkPassword' name='checkPassword' label={t('profile.retypePassword')} type='password' value={checkPassword} onChange={this.onChange} className={classes.textField} />
                          </Grid>
                          <Grid item xs={12} align='center' className={classes.magrinTopBlock}>
                            <ClearBrilliantButton variant='contained' color='primary' onClick={this.changePassword}>
                              {t('profile.updateButton')}
                            </ClearBrilliantButton>
                          </Grid>
                        </form>
                      </Grid>
                      <Grid item sm={4} xs={12} container spacing={4} alignItems='center' justifyContent='center'>
                        <form onSubmit={this.communcationOptions}>
                          <Grid item xs={12}>
                            <Typography variant='h6' gutterBottom>
                              {t('profile.notifcationTitle')}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <FormControlLabel control={<Checkbox checked={emailCommuncation} onChange={this.handleChange} name='emailCommuncation' color='primary' />} label={t('profile.emailCommunication')} />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControlLabel control={<Checkbox checked={textCommunication} onChange={this.handleChange} name='textCommunication' color='primary' />} label={t('profile.textMessageCommunication')} />
                          </Grid>

                          <Grid item xs={12}>
                            {textCommunication ? <TextField id='phoneNumber' label={t('profile.cellPhone')} autoComplete='cell-phone-number' name='phoneNumber' value={phoneNumber} onChange={this.onChange} className={classes.textField} /> : ''}
                          </Grid>

                          <Grid item xs={12} align='center' className={classes.magrinTopBlock}>
                            <ClearBrilliantButton variant='contained' color='primary' onClick={this.communcationOptions}>
                              {t('profile.updateNotication')}
                            </ClearBrilliantButton>
                          </Grid>
                        </form>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Snackbar open={profileUpdated} autoHideDuration={6000} onClose={this.closePopUps}>
                    <Alert onClose={this.closePopUps} severity='success'>
                      {t('profile.profileUpdated')}
                    </Alert>
                  </Snackbar>
                  <Snackbar open={authPopUp} autoHideDuration={6000} onClose={this.closePopUps}>
                    <Alert onClose={this.closePopUps} severity='success'>
                      {authMessage}
                    </Alert>
                  </Snackbar>
                  <Snackbar open={authErrorPopUp} autoHideDuration={6000} onClose={this.closePopUps}>
                    <Alert onClose={this.closePopUps} severity='error'>
                      {authError}
                    </Alert>
                  </Snackbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className='meta-react'>
          <LogoHeader t={t} />
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className={classes.root}>
                  <Grid container spacing={3} justifyContent='center'>
                    <Grid item xs={12} align='center'>
                      <LoadingBlock />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

ProfilePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  //console.log('this is my state', state);
  return {
    auth: state.firebase.auth,
    user: state.firebase.profile,
    authError: state.auth.authError,
    authMessage: state.auth.authMessage,
    authPopUp: state.auth.authPopUp,
    authErrorPopUp: state.auth.authErrorPopUp,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserPassword: (user) => dispatch(updateUserPassword(user)),
    closeAuthPopUps: () => dispatch(closeAuthPopUps()),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withTranslation(),
  firestoreConnect((props) => [
    //{ collection: 'promos' }
  ])
)(ProfilePage);
